export const handleUnload = () => {
  // if (activeDocuments.length > 0) {
  //   navigator.sendBeacon(
  //     `${mainConfig.url}/saveTempDocs.php`,
  //     JSON.stringify(activeDocuments)
  //   );
  // }
};

export const handleVisibilityChange = () => {
  if (document.visibilityState === "hidden") {
    handleUnload();
  }
};

export const handleBeforeUnload = (event: BeforeUnloadEvent) => {
  // const data = getData();
  // if (data) {
  // Mostrar advertencia al salir
  event.preventDefault();
  event.returnValue = "";
  // }
};
